import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { DESIGN_INLINE, DESIGN_INLINE_VERTICAL, DESIGN_VERTICAL } from '../../../ChannelList/constants/carousels';
import {
  INLINE_PLAYER_INSTANCE_KEY,
  INLINE_VERTICAL_PLAYER_INSTANCE_KEY,
  MAIN_PLAYER_INSTANCE_KEY,
  VERTICAL_PLAYER_INSTANCE_KEY,
} from './constants';
import { ASPECT_RATIO_9X16, ASPECT_RATIO_16X9 } from '@/modules/common/components/Player/constants/aspectRatio';

import * as commonSelectors from '../../redux/selectors/common';
import { isMobileUserAgent } from '@/modules/common/helpers/userAgent';

import PlayerProvider from './PlayerProvider';

function AllPlayersProvider(props) {
  const widgetOrigin = useSelector(commonSelectors.widgetOriginSelector);
  const widgetPath = useSelector(commonSelectors.widgetPathSelector);
  const publisher = useSelector(commonSelectors.publisherSelector);
  const player = useSelector(commonSelectors.playerSelector);
  const inlinePlayer = useSelector(commonSelectors.inlinePlayerSelector);
  const dockMobile = useSelector(commonSelectors.dockMobileSelector);
  const offsetTop = useSelector(commonSelectors.offsetTopSelector);
  const autoplay = useSelector(commonSelectors.autoplaySelector);
  const autoplayMobile = useSelector(commonSelectors.autoplayMobileSelector);
  const sound = useSelector(commonSelectors.soundSelector);
  const soundMobile = useSelector(commonSelectors.soundMobileSelector);
  const channels = useSelector(commonSelectors.channelsSelector);
  const verticalPlayer = useSelector(commonSelectors.verticalPlayerSelector);
  const inlineVerticalPlayer = useSelector(commonSelectors.inlineVerticalPlayerSelector);

  let widgetProviders = (
    <PlayerProvider
      widgetOrigin={widgetOrigin}
      widgetPath={widgetPath}
      instanceKey={MAIN_PLAYER_INSTANCE_KEY}
      publisherSlug={publisher.slug}
      playerName={player.name}
      autoplay={isMobileUserAgent ? autoplayMobile : autoplay}
      sound={isMobileUserAgent ? soundMobile : sound}
      offsetTop={isMobileUserAgent ? offsetTop : 0}
      enableFloating={dockMobile}
      aspectRatio={ASPECT_RATIO_16X9}
    >
      {props.children}
    </PlayerProvider>
  );

  let initInlinePlayer = false;
  let initInlineVerticalPlayer = false;
  let initVerticalPlayer = false;

  channels.forEach((channel) => {
    if (channel.design === DESIGN_INLINE) {
      initInlinePlayer = true;
    }

    if (channel.design === DESIGN_VERTICAL) {
      initVerticalPlayer = true;
    }

    if (channel.design === DESIGN_INLINE_VERTICAL) {
      initInlineVerticalPlayer = true;
      initVerticalPlayer = true;
    }
  });

  if (initInlinePlayer) {
    widgetProviders = (
      <PlayerProvider
        widgetOrigin={widgetOrigin}
        widgetPath={widgetPath}
        instanceKey={INLINE_PLAYER_INSTANCE_KEY}
        publisherSlug={publisher.slug}
        playerName={inlinePlayer.name}
        autoplay
        sound={false}
        offsetTop={0}
        enableFloating={false}
        aspectRatio={ASPECT_RATIO_16X9}
      >
        {widgetProviders}
      </PlayerProvider>
    );
  }

  if (initVerticalPlayer) {
    widgetProviders = (
      <PlayerProvider
        widgetOrigin={widgetOrigin}
        widgetPath={widgetPath}
        instanceKey={VERTICAL_PLAYER_INSTANCE_KEY}
        publisherSlug={publisher.slug}
        playerName={verticalPlayer.name}
        autoplay={isMobileUserAgent ? autoplayMobile : autoplay}
        sound={isMobileUserAgent ? soundMobile : sound}
        offsetTop={isMobileUserAgent ? offsetTop : 0}
        enableFloating={dockMobile}
        aspectRatio={ASPECT_RATIO_9X16}
      >
        {widgetProviders}
      </PlayerProvider>
    );
  }

  if (initInlineVerticalPlayer) {
    widgetProviders = (
      <PlayerProvider
        widgetOrigin={widgetOrigin}
        widgetPath={widgetPath}
        instanceKey={INLINE_VERTICAL_PLAYER_INSTANCE_KEY}
        publisherSlug={publisher.slug}
        playerName={inlineVerticalPlayer.name}
        autoplay
        sound={false}
        offsetTop={0}
        enableFloating={false}
        aspectRatio={ASPECT_RATIO_9X16}
      >
        {widgetProviders}
      </PlayerProvider>
    );
  }

  return widgetProviders;
}

AllPlayersProvider.propTypes = {
  children: PropTypes.node,
};

export default AllPlayersProvider;
